import DepartmentsRouter from './DepartmentsRouter';

export default DepartmentsRouter;
